import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useContractForm } from "../../Hook/Contract/useContractForm";
import { FileEarmarkMedical } from "react-bootstrap-icons";
import Form from "../../Components/Form/form";

export default function ContractForm({
    show,
    onClose,
    idClient,
    contract = null,
}) {
    const { t } = useTranslation(); // Translation hook

    const {
        isEditing,
        formContract,
        setFormContract,
        handleFormSubmit,
        handleFormCancel,
    } = useContractForm({ idClient, contract, onClose });

    const handleFormChange = (newFormData) => {
        try {
            const current = JSON.stringify(formContract || {});
            const incoming = JSON.stringify(newFormData || {});
            if (current !== incoming) {
                setFormContract(newFormData);
            }
        } catch (e) {
            // Fallback: if stringify fails for some reason, set anyway
            setFormContract(newFormData);
        }
    };

    const formConfig = {
        isEditing,
        submitText: isEditing
            ? t("common.actions.update")
            : t("common.actions.save"),
        sections: [
            {
                title: t("contract.form.sections.basic-info"),
                icon: FileEarmarkMedical,
                columns: 2,
                fields: [
                    {
                        name: "description",
                        label: t("contract.form.field.description.label"),
                        type: "text",
                        placeholder: t(
                            "contract.form.placeholders.description"
                        ),
                        required: true,
                        errorMessages: {
                            required: t(
                                "contract.form.field.description.errors.required"
                            ),
                        },
                    },
                    {
                        name: "is_active",
                        label: t("contract.form.field.is_active"),
                        type: "checkbox",
                    },
                ],
            },
        ],
        onSubmit: async () => {
            handleFormSubmit();
        },
        onCancel: () => handleFormCancel(),
        onChange: (newFormData) => handleFormChange(newFormData),
        data: formContract,
    };

    return (
        <Modal
            show={show}
            size="xl"
            backdrop="static"
            keyboard={false}
            centered
            aria-labelledby="example-modal-sizes-title-lg"
            className="modal-create-user"
        >
            <Modal.Header>
                <Modal.Title>
                    {formContract.id
                        ? `${t("contract.form.title.edit")} ${formContract.id}`
                        : t("contract.form.title.new")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form {...formConfig} />
            </Modal.Body>
        </Modal>
    );
}
